import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonios" className="border-t-2 border-volt/25 bg-night" data-id="element-161" data-mp="1n0aczfdwoovk">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-162" data-mp="1r140w8rcm3og">
        <Reveal className="text-center" data-id="element-163" data-mp="1qz9kn7r0uzqp">
          <h2 id="testimonios" className="font-display text-xl uppercase leading-tight text-white sm:text-3xl lg:text-4xl" data-id="element-164" data-mp="1d0tat7xv4t4c">
            Lo que dicen quienes ya empezaron
          </h2>
          <p className="mt-1 text-[0.85rem] font-bold text-volt sm:text-base" data-id="element-165" data-mp="142r369jmj283">
            De cero a comprender la lógica de una instalación.
          </p>
        </Reveal>

        <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-166" data-mp="2yexrma1j3fic">
          {testimonials.map((item, i) => <Reveal key={item.name} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-white/10 bg-carbon p-4" data-id="element-167" data-mp="32fhpjftxen5j" data-mpi={i}>
              <div className="flex items-center justify-between" data-id="element-168" data-mp="2q1ybu705gfj9">
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-169" data-mp="34rnj8jyu5frz">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} size={13} className="fill-volt text-volt" data-id="element-170" data-mp="2zt2pn3e39uci" data-mpi={s} />)}
                </div>
                <QuoteIcon size={16} className="text-volt/40" aria-hidden="true" data-id="element-171" data-mp="275q32t7xhmj7" />
              </div>
              <p className="mt-2 text-[0.8rem] leading-snug text-white sm:text-sm" data-id="element-172" data-mp="2h08c8dw46aae">
                “{item.text}”
              </p>
              <div className="mt-auto pt-3" data-id="element-173" data-mp="1ci4nlu9u5jx">
                <p className="font-display text-sm uppercase text-volt" data-id="element-174" data-mp="3sfwzl6da5bbq">
                  {item.name}
                </p>
                <p className="text-[0.7rem] text-steel sm:text-xs" data-id="element-175" data-mp="3e8xc58b5r3k">
                  {item.role} · {item.place}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}